import React from 'react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import CssBaseline from '@material-ui/core/CssBaseline';
import AnalyticsProvider from 'components/AnalyticsProvider';
import store from 'store/store';

// Themes
import theme from 'styles/theme';
import { ThemeProvider } from '@material-ui/styles';

interface Props {
  children: React.ReactNode;
}

function AppProvider({ children }: Props) {
  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider
            maxSnack={3}
            hideIconVariant
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <Provider store={store}>
              <AnalyticsProvider>{children}</AnalyticsProvider>
            </Provider>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </>
  );
}

export default AppProvider;
